
import Vue from 'vue'
export default Vue.extend({
    props: {
        size: {type: String},
        width: {type: String},
        color: {type: String, default: 'mainNew'}
    }
})
